import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const customerAtom = atomWithStorage("user", "");

export const userAtom = atomWithStorage("customer", "");

export const clubStateAtom = atomWithStorage("clubState", "");

export const expStateAtom = atomWithStorage("ExpState", "");

export const levelsAtom = atomWithStorage("levels", []);

export const isOpenMailPreferencesPopup = atom(false);

export const rememberMeAtom = atom(false);
